



import { Vue, Component } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import OrderDepositWait from './OrderDepositWait.vue';

@Component({
  components: { AdminIframe, OrderDepositWait },
})
export default class OrderDepositWaitIframe extends Vue {
  private get remoteSrc() {
    const query = this.$route.query;
    const queryObject = { ...query, serviceType: 'PRO' };
    const queryString = new URLSearchParams(queryObject).toString();
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + '/fulfillment/order/deposit-wait-list' + '?' + queryString;
    return src;
  }
}
